import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaBookmark } from "react-icons/fa6";
import { FiLogOut } from "react-icons/fi";
import { FaUserCircle } from 'react-icons/fa';
import { FaHome } from "react-icons/fa";
import { GoHeartFill } from "react-icons/go";
import Logo from '../images/logo.png';
import { Link, useNavigate, useLocation } from "react-router-dom";
import { buildApiUrl } from "../utils/api";

function UserMenu() {
    const [userName, setUserName] = useState('');
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const fetchUserDetails = async () => {
            try {
                const token = localStorage.getItem('token');
                if (token) {
                    const userResponse = await axios.get(buildApiUrl('/api/user/details'), {
                        headers: { Authorization: `Bearer ${token}` }
                    });
                    setUserName(userResponse.data.user.name); // Fetch and set user name
                }
            } catch (error) {
                console.error('Error fetching user details', error);
            }
        };
        fetchUserDetails();
    }, []);

    const handleLogout = () => {
        localStorage.removeItem('token'); // Clear token on logout
        navigate('/userLogin'); // Redirect to login page
    };

    return (
        <div className="menubar mt-4 shadow">
            <div className="logo" style={{ marginTop: "10px" }}>
                <img src={Logo} alt="logo" />
            </div>
            <div className="menus">
                <ul>
                    <li>
                        <FaHome />
                        <Link
                            to="/userDetails"
                            style={{
                                textDecoration: "none",
                                color: "#000",
                                fontWeight: location.pathname === '/userDetails' ? 'bold' : 'normal',
                                marginLeft:"10px"
                            }}
                        >
                            Home Page
                        </Link>
                    </li>
                    <hr />
                    <li>
                        <GoHeartFill />
                        <Link
                            to="/userDetails/userWishList"
                            style={{
                                textDecoration: "none",
                                color: "#000",
                                fontWeight: location.pathname === '/userDetails/userWishList' ? 'bold' : 'normal',
                                marginLeft:"10px"
                            }}
                        >
                            Wishlist
                        </Link>
                    </li>
                    <hr />
                    <li>
                        <FaBookmark />
                        <Link
                            to="/userDetails/bookingList"
                            style={{
                                textDecoration: "none",
                                color: "#000",
                                fontWeight: location.pathname === '/userDetails/bookingList' ? 'bold' : 'normal',
                                marginLeft:"10px"
                            }}
                        >
                            Bookings Details
                        </Link>
                    </li>
                    <hr />
                    <li onClick={handleLogout} style={{ cursor: "pointer", color: "#000" }}>
                        <FiLogOut /> Logout
                    </li>
                </ul>
            </div>
            <div className="currentUser" style={{ backgroundColor: "#E0A75E" }}>
                <h6><FaUserCircle /> Hello, {userName || "Someone"}</h6>
            </div>
        </div>
    );
}

export default UserMenu;
